import { useEffect, useState } from "react"

import { calculateDurationLeft, calculatePercentage } from "~/utils/TimerUtils"
import { formattedDuration } from "~/utils/TimeFormatter"

import "./Countdown.scss"
import { Timer } from "~/types"

type CountdownProps = {
  timer?: Timer
  onTick?: (durationLeft: number) => void
  onEnded?: () => void
}

function Countdown(props: CountdownProps) {
  const { timer, onTick, onEnded } = props
  const [durationLeft, setDurationLeft] = useState(
    timer ? calculateDurationLeft(timer) : 0,
  )

  useEffect(() => {
    if (!timer) return

    let timerAtZero = false
    const updateDuration = () => {
      const durationLeftNow = calculateDurationLeft(timer)
      setDurationLeft(durationLeftNow)
      onTick?.(durationLeftNow)
      if (!timerAtZero && durationLeftNow == 0) {
        timerAtZero = true
        onEnded?.()
      }
      return updateDuration
    }
    const interval = setInterval(updateDuration, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [timer, onTick, onEnded, setDurationLeft])

  return (
    <>
      <div
        className={`Countdown__progress Countdown__progress--${
          timer?.break ? "break" : "work"
        }`}
        style={{
          // @ts-expect-error CSS variable
          "--percentage": calculatePercentage(timer) + "%",
        }}
      />
      <div className="Countdown__duration">
        {formattedDuration(durationLeft)}
      </div>
    </>
  )
}

export default Countdown
